import { Component, Input } from '@angular/core';
import { getStyles } from './styles';
import { AssessmentReportTemplate, IReport } from '@interfaces/index';

@Component({
  selector: 'app-report-share',
  template: ''
})
export class ReportShareComponent {

  @Input() report!: IReport;
  @Input() download = false;

  get styles(): any {
    return getStyles(this.download);
  }

  get isCoachingStyles(): boolean {
    return ([AssessmentReportTemplate.CoachingStyles, AssessmentReportTemplate.CoachingStylesV2] as AssessmentReportTemplate[]).includes(
      this.report.templateId as AssessmentReportTemplate
    );
  }

  get isFacilitatorTemplate(): boolean {
    return this.report.templateId === AssessmentReportTemplate.FacilitatorStyles;
  }

  get isFacilitator(): boolean {
    return this.report?.templateType?.toLowerCase().includes('facilitator') ?? false;
  }

  get isDirectReport(): boolean {
    if (this.report.templateId == AssessmentReportTemplate.DirectReport){
    return true;
    } else {
      return false
    }
  }

  get isCoacheePreference(): boolean {
    if (this.report.templateId == AssessmentReportTemplate.CoacheePreferences){
    return true;
    } else {
      return false
    }
  }

  get isPeerToPeer(): boolean {
    if (this.report.templateId == AssessmentReportTemplate.PeerToPeer){
    return true;
    } else {
      return false
    }
  }
}
